import React, { useCallback, useEffect } from "react";
import { useState } from "react";
import { useNavigate } from "react-router";
import NavLi from "./NavLi";
import swal from "sweetalert";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import navSlice from "../../slice/nav";
export default function Nav() {
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const [coachingLiList, setCoachingLiList] = useState(false);
  const [systyemLiList, setSystemLiList] = useState(false);
  const systemcategoryIndex = useSelector(
    (state) => state.nav.systemcategoryIndex
  );
  const coachingcategoryIndex = useSelector(
    (state) => state.nav.coachingcategoryIndex
  );
  const showmemberli = useSelector((state) => state.nav.showmemberli);
  const showcoachingli = useSelector((state) => state.nav.showcoachingli);
  const showserviceli = useSelector((state) => state.nav.showserviceli);
  const showpayli = useSelector((state) => state.nav.showpayli);
  const showqnali = useSelector((state) => state.nav.showqnali);
  const showtalkli = useSelector((state) => state.nav.showtalkli);
  const showpostli = useSelector((state) => state.nav.showpostli);
  const showsystemli = useSelector((state) => state.nav.showsystemli);
  const showtalkAdli = useSelector((state) => state.nav.showsystemli);

  const [systemhovered, setsystemHovered] = useState(-1);
  const [coachinghovered, setcoachingHovered] = useState(-1);
  const [memberLihovered, setmemberLiHovered] = useState(false);
  const memberLiborderLeft = memberLihovered
    ? "6px solid #4674FE"
    : "6px solid white";
  const memberLifontWeight = memberLihovered ? "600" : "400";

  const [coachingLihovered, setcoachingLiHovered] = useState(false);
  const coachingLiborderLeft = coachingLihovered
    ? "6px solid #4674FE"
    : "6px solid white";
  const coachingLifontWeight = coachingLihovered ? "600" : "400";

  const [serviceLihovered, setserviceLiHovered] = useState(false);
  const serviceLiborderLeft = serviceLihovered
    ? "6px solid #4674FE"
    : "6px solid white";
  const serviceLifontWeight = serviceLihovered ? "600" : "400";

  const [payLihovered, setpayLiHovered] = useState(false);
  const payLiborderLeft = payLihovered
    ? "6px solid #4674FE"
    : "6px solid white";
  const payLifontWeight = payLihovered ? "600" : "400";

  const [talkAdLihovered, setTalkAdLiHovered] = useState(false);
  const talkAdLiborderLeft = talkAdLihovered
    ? "6px solid #4674FE"
    : "6px solid white";
  const talkAdLifontWeight = payLihovered ? "600" : "400";

  const [qnaLihovered, setqnaLiHovered] = useState(false);
  const qnaLiborderLeft = qnaLihovered
    ? "6px solid #4674FE"
    : "6px solid white";
  const qnaLifontWeight = qnaLihovered ? "600" : "400";

  const [talkLihovered, settalkLiHovered] = useState(false);
  const talkLiborderLeft = talkLihovered
    ? "6px solid #4674FE"
    : "6px solid white";
  const talkLifontWeight = talkLihovered ? "600" : "400";

  const [postLihovered, setpostLiHovered] = useState(false);
  const postLiborderLeft = postLihovered
    ? "6px solid #4674FE"
    : "6px solid white";
  const postLifontWeight = postLihovered ? "600" : "400";

  const [hovered, setHovered] = useState(false);
  const borderLeft = hovered ? "6px solid #4674FE" : "6px solid white";
  const fontWeight = hovered ? "600" : "400";

  const handleNavigate_member = () => {
    dispatch(navSlice.actions.setCoachingCategoryIndex(-1));
    dispatch(navSlice.actions.setSystemCategoryIndex(-1));
    navigation("/member");
  };
  const handleNavigate_coaching = () => {
    dispatch(navSlice.actions.setCoachingCategoryIndex(-1));
    dispatch(navSlice.actions.setSystemCategoryIndex(-1));
    navigation("/coaching");
  };
  const handleNavigate_notice = () => {
    dispatch(navSlice.actions.setCoachingCategoryIndex(-1));
    dispatch(navSlice.actions.setSystemCategoryIndex(-1));
    navigation("/notice");
  };
  const handleNavigate_pay = () => {
    dispatch(navSlice.actions.setCoachingCategoryIndex(-1));
    dispatch(navSlice.actions.setSystemCategoryIndex(-1));
    navigation("/adsence");
  };
  const handleNavigate_talkAd = () => {
    dispatch(navSlice.actions.setCoachingCategoryIndex(-1));
    dispatch(navSlice.actions.setSystemCategoryIndex(-1));
    navigation("/talkad");
  };
  const handleNavigate_qna = () => {
    dispatch(navSlice.actions.setCoachingCategoryIndex(-1));
    dispatch(navSlice.actions.setSystemCategoryIndex(-1));
    navigation("/faq");
  };
  const handleNavigate_talk = () => {
    dispatch(navSlice.actions.setCoachingCategoryIndex(-1));
    dispatch(navSlice.actions.setSystemCategoryIndex(-1));
    navigation("/talk");
  };
  const handleNavigate_system = () => {
    // dispatch(navSlice.actions.setCoachingCategoryIndex(-1))
    // dispatch(navSlice.actions.setSystemCategoryIndex(-1))
    //navigation("/system");
  };
  const handleNavigate_post = () => {
    dispatch(navSlice.actions.setCoachingCategoryIndex(-1));
    dispatch(navSlice.actions.setSystemCategoryIndex(-1));
    navigation("/post");
  };
  const handleNavigate_home = () => {
    dispatch(navSlice.actions.setCoachingCategoryIndex(-1));
    dispatch(navSlice.actions.setSystemCategoryIndex(-1));
    dispatch(navSlice.actions.closeli());
    navigation("/home");
  };
  const handleNavigate_coaching_management = () => {
    dispatch(navSlice.actions.setCoachingCategoryIndex(-1));
    dispatch(navSlice.actions.setSystemCategoryIndex(-1));
    navigation("/coaching/management");
  };
  const handleNavigate_coaching_chat = () => {
    dispatch(navSlice.actions.setCoachingCategoryIndex(-1));
    dispatch(navSlice.actions.setSystemCategoryIndex(-1));
    navigation("/coaching/chat/management");
  };
  const handleNavigate_coaching_group = () => {
    dispatch(navSlice.actions.setCoachingCategoryIndex(-1));
    dispatch(navSlice.actions.setSystemCategoryIndex(-1));
    navigation("/coaching/group/management");
  };
  const handleNavigate_coaching_question = () => {
    dispatch(navSlice.actions.closeli());
    dispatch(navSlice.actions.setSystemCategoryIndex(-1));
    dispatch(navSlice.actions.updatecoachingli(true));
    navigation("/coaching/question/management");
  };
  const handleNavigate_system_role = () => {
    dispatch(navSlice.actions.closeli());
    dispatch(navSlice.actions.setCoachingCategoryIndex(-1));
    dispatch(navSlice.actions.updatesystemli(true));
    setSystemLiList(true);

    navigation("/system/role");
  };
  const handleNavigate_system_version = () => {
    dispatch(navSlice.actions.closeli());
    dispatch(navSlice.actions.setCoachingCategoryIndex(-1));
    dispatch(navSlice.actions.updatesystemli(true));
    setSystemLiList(true);
    navigation("/system/version");
  };
  const handlewaiting = () => {
    swal("준비중입니다", "", "warning");
  };
  const coachingitem = [
    { title: "코칭 관리", navigation: handlewaiting },
    { title: "코칭 채팅", navigation: handlewaiting },
    { title: "그룹 관리", navigation: handlewaiting },
    { title: "질문권 관리", navigation: handleNavigate_coaching_question },
  ];
  const systemitem = [
    { title: "관리자 관리", navigation: handleNavigate_system_role },
    { title: "버전 관리", navigation: handleNavigate_system_version },
  ];

  return (
    <Container>
      <div style={{ margin: 40, marginBottom: 20 }}>
        <img
          style={{ width: 155.96, height: 40, cursor: "pointer" }}
          src={process.env.PUBLIC_URL + "/Group.png"}
          alt="logo"
          className="Nav_logo"
          onClick={handleNavigate_home}
        />
      </div>
      <div>
        <ul>
          <Navli
            onMouseOver={() => setmemberLiHovered(true)}
            onMouseLeave={() => setmemberLiHovered(false)}
            onClick={() => {
              dispatch(navSlice.actions.closeli());
              handleNavigate_member();
            }}
            style={{
              borderLeft: memberLiborderLeft,
              fontWeight: memberLifontWeight,
              ...(showmemberli && {
                borderLeft: "6px solid #4674FE",
                fontWeight: 600,
              }),
            }}
          >
            <a>회원 관리</a>
          </Navli>
          <Navli
            onMouseOver={() => setcoachingLiHovered(true)}
            onMouseLeave={() => setcoachingLiHovered(false)}
            onClick={() => {
              dispatch(navSlice.actions.closeli());
              dispatch(navSlice.actions.updatecoachingli(true));
              setCoachingLiList(!coachingLiList);
              //navigation("/system");
            }}
            style={{
              borderLeft: coachingLiborderLeft,
              fontWeight: coachingLifontWeight,
              ...(showcoachingli && {
                borderLeft: "6px solid #4674FE",
                fontWeight: 600,
              }),
            }}
          >
            <a>코칭 및 질문권 관리</a>
            {coachingLiList == true ? (
              <img
                src={`${process.env.PUBLIC_URL}/ico_arrow_bottom_black.png`}
                style={{
                  width: 16,
                  height: 16,
                  float: "right",
                  marginTop: 16,
                  marginRight: 28,
                }}
              />
            ) : (
              <img
                src={`${process.env.PUBLIC_URL}/ico_arrow_right_black.png`}
                style={{
                  width: 16,
                  height: 16,
                  float: "right",
                  marginTop: 16,
                  marginRight: 28,
                }}
              />
            )}
          </Navli>
          {coachingLiList &&
            coachingitem.map((item, index) => (
              <Navul
                key={index}
                onClick={() => {
                  dispatch(navSlice.actions.setCoachingCategoryIndex(index));
                  item.navigation();
                }}
                onMouseOver={() => setcoachingHovered(index)}
                onMouseLeave={() => setcoachingHovered(-1)}
                style={{
                  ...(index == coachinghovered && {
                    fontWeight: 600,
                  }),
                  ...(index == coachingcategoryIndex && {
                    fontWeight: 600,
                  }),
                }}
              >
                <a>{item.title}</a>
              </Navul>
            ))}
          <Navli
            onMouseOver={() => setserviceLiHovered(true)}
            onMouseLeave={() => setserviceLiHovered(false)}
            onClick={() => {
              dispatch(navSlice.actions.closeli());
              handleNavigate_notice();
            }}
            style={{
              borderLeft: serviceLiborderLeft,
              fontWeight: serviceLifontWeight,
              ...(showserviceli && {
                borderLeft: "6px solid #4674FE",
                fontWeight: 600,
              }),
            }}
          >
            <a>공지사항</a>
          </Navli>
          <Navli
            onMouseOver={() => setpayLiHovered(true)}
            onMouseLeave={() => setpayLiHovered(false)}
            onClick={() => {
              dispatch(navSlice.actions.closeli());
              handleNavigate_pay();
            }}
            style={{
              borderLeft: payLiborderLeft,
              fontWeight: payLifontWeight,
              ...(showpayli && {
                borderLeft: "6px solid #4674FE",
                fontWeight: 600,
              }),
            }}
          >
            <a>배너 광고관리</a>
          </Navli>
          <Navli
            onMouseOver={() => setqnaLiHovered(true)}
            onMouseLeave={() => setqnaLiHovered(false)}
            onClick={() => {
              dispatch(navSlice.actions.closeli());
              handleNavigate_qna();
            }}
            style={{
              borderLeft: qnaLiborderLeft,
              fontWeight: qnaLifontWeight,
              ...(showqnali && {
                borderLeft: "6px solid #4674FE",
                fontWeight: 600,
              }),
            }}
          >
            <a>자주 묻는 질문</a>
          </Navli>
          <Navli
            onMouseOver={() => settalkLiHovered(true)}
            onMouseLeave={() => settalkLiHovered(false)}
            onClick={() => {
              dispatch(navSlice.actions.closeli());
              handleNavigate_talk();
            }}
            style={{
              borderLeft: talkLiborderLeft,
              fontWeight: talkLifontWeight,
              ...(showtalkli && {
                borderLeft: "6px solid #4674FE",
                fontWeight: 600,
              }),
            }}
          >
            <a>TALK</a>
          </Navli>
          <Navli
            onMouseOver={() => setTalkAdLiHovered(true)}
            onMouseLeave={() => setTalkAdLiHovered(false)}
            onClick={() => {
              dispatch(navSlice.actions.closeli());
              handleNavigate_talkAd();
            }}
            style={{
              borderLeft: talkAdLiborderLeft,
              fontWeight: talkAdLifontWeight,
              ...(showtalkAdli && {
                borderLeft: "6px solid #4674FE",
                fontWeight: 600,
              }),
            }}
          >
            <a>TALKAd</a>
          </Navli>
          <Navli
            onMouseOver={() => setpostLiHovered(true)}
            onMouseLeave={() => setpostLiHovered(false)}
            onClick={() => {
              dispatch(navSlice.actions.closeli());
              handleNavigate_post();
            }}
            style={{
              borderLeft: postLiborderLeft,
              fontWeight: postLifontWeight,
              ...(showpostli && {
                borderLeft: "6px solid #4674FE",
                fontWeight: 600,
              }),
            }}
          >
            <a>포스트 관리</a>
          </Navli>

          <Navli
            onMouseOver={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            onClick={() => {
              dispatch(navSlice.actions.closeli());
              dispatch(navSlice.actions.updatesystemli(true));
              setSystemLiList(!systyemLiList);
              //navigation("/system");
            }}
            style={{
              borderLeft,
              fontWeight,
              ...(showsystemli && {
                borderLeft: "6px solid #4674FE",
                fontWeight: 600,
              }),
            }}
          >
            <a>시스템 관리</a>
            {systyemLiList == true ? (
              <img
                src={`${process.env.PUBLIC_URL}/ico_arrow_bottom_black.png`}
                style={{
                  width: 16,
                  height: 16,
                  float: "right",
                  marginTop: 16,
                  marginRight: 28,
                }}
              />
            ) : (
              <img
                src={`${process.env.PUBLIC_URL}/ico_arrow_right_black.png`}
                style={{
                  width: 16,
                  height: 16,
                  float: "right",
                  marginTop: 16,
                  marginRight: 28,
                }}
              />
            )}
          </Navli>
          {systyemLiList &&
            systemitem.map((item, index) => (
              <Navul
                key={index}
                onClick={() => {
                  dispatch(navSlice.actions.setSystemCategoryIndex(index));
                  item.navigation();
                  setSystemLiList(true);
                }}
                onMouseOver={() => setsystemHovered(index)}
                onMouseLeave={() => setsystemHovered(-1)}
                style={{
                  ...(index == systemhovered && {
                    fontWeight: 600,
                  }),
                  ...(index == systemcategoryIndex && {
                    fontWeight: 600,
                  }),
                }}
              >
                <a>{item.title}</a>
              </Navul>
            ))}
        </ul>
      </div>
    </Container>
  );
}
const Container = styled.nav`
  display: block;
  width: 256px;
  background-color: rgb(255, 255, 255);
  border-right: 1px solid #e9eaee;
  line-height: 48px;
  min-height: 100vh;
`;
const Navul = styled.li`
  cursor: pointer;
  padding-left: 40px;
  height: 34px;
  line-height: 34px;
  font-size: 14px;
`;
const Navli = styled.li`
  padding-left: 34px;
  height: 48px;
  line-heigth: 48px;
  display: block;
  justify-content: space-between;
  margin-bottom: 10px;
  width: calc(100% - 6px - 34px);
  border-left: 6px solid white;
  cursor: pointer;
`;
